import { RELEASE_URL } from './env';

// The Builder is another site, so it opens in a new tab and the reader keeps their place here.
export const openBuilder = () => {
  window.open(RELEASE_URL, '_blank', 'noopener,noreferrer');
};
